/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ---------------------------------------------------------------------------
 * VARIANT OPTION AVAILABILITY GUARD
 *
 * 41 products in this catalogue have a SPARSE option matrix - the supplier does
 * not stock every combination (e.g. on the 50x42mm PVC nosing, Red exists only
 * in 1.1m and Brown only in 1.8m). The theme's option dropdowns list every value
 * of every option, so choosing one of those values while another select still
 * holds an incompatible one leaves the form on a combination that has no variant
 * at all: the price disappears, the gallery never moves to that colour's image,
 * and add-to-cart is replaced by the "call us" fallback. Customers read that as
 * a broken page and leave.
 *
 * On every option change this:
 *   1. treats the value the customer just picked as fixed,
 *   2. picks the real variant that keeps the most of their other choices,
 *   3. moves the other selects onto that variant, and
 *   4. greys out the values that do not exist alongside their choice.
 *
 * The form therefore always lands on a real variant, and the gallery, price and
 * add-to-cart follow. Products with a complete matrix are untouched.
 *
 * Self-contained: reads /products/<handle>.js, only touches native selects in a
 * product form belonging to that product, and re-fires the theme's own change
 * event so all existing theme behaviour still runs. Any failure is swallowed so
 * it can never break a product page.
 * ------------------------------------------------------------------------- */
(function () {
  var handle = location.pathname.indexOf('/products/') === -1 ? '' : location.pathname.split('/products/')[1].split(/[?#]/)[0];

  var busy = false;

  function collect(product, root) {
    var ids = {};
    product.variants.forEach(function (v) { ids[String(v.id)] = true; });

    var groups = [];
    Array.prototype.forEach.call((root || document).querySelectorAll('form.product-form'), function (form) {
      var idField = form.querySelector('[name="id"]');
      if (!idField) { return; }

      var candidates = idField.tagName === 'SELECT'
        ? Array.prototype.map.call(idField.options, function (o) { return o.value; })
        : [idField.value];

      var mine = candidates.some(function (x) { return ids[String(x)] === true; });
      if (!mine) { return; }

      var selects = Array.prototype.slice.call(form.querySelectorAll('select.product-form__single-selector'));
      if (selects.length > 1 && selects.length === product.options.length) { groups.push(selects); }
    });
    return groups;
  }

  function apply(variants, selects, changed, silent) {
    if (busy) { return; }

    var chosen = selects[changed].value;
    var current = selects.map(function (s) { return s.value; });

    // Every variant that honours the value the customer just picked.
    var candidates = variants.filter(function (v) { return v.options[changed] === chosen; });
    if (!candidates.length) { return; }

    // Grey out the values that cannot be had alongside that choice.
    selects.forEach(function (select, i) {
      if (i === changed) { return; }
      var allowed = {};
      candidates.forEach(function (v) { allowed[v.options[i]] = true; });
      Array.prototype.forEach.call(select.options, function (option) {
        var ok = allowed[option.value] === true;
        option.disabled = !ok;
        option.hidden = !ok;
      });
    });

    // Keep as much of the rest of their selection as actually exists.
    var best = null, bestScore = -1;
    candidates.forEach(function (v) {
      var score = 0;
      for (var i = 0; i < selects.length; i++) {
        if (i !== changed && v.options[i] === current[i]) { score++; }
      }
      if (score > bestScore) { bestScore = score; best = v; }
    });
    if (!best) { return; }

    var corrected = null;
    selects.forEach(function (select, i) {
      if (i === changed) { return; }
      if (select.value !== best.options[i]) {
        select.value = best.options[i];
        corrected = select;
      }
    });

    if (corrected && !silent) {
      busy = true;
      corrected.dispatchEvent(new Event('change', { bubbles: true }));
      busy = false;
    }
  }

  function bind(product, root) {
    if (!product || !product.variants || !product.options || product.options.length < 2) { return; }
    collect(product, root).forEach(function (selects) {
      if (selects[0].dataset.snOptionsBound === '1') { return; }
      selects.forEach(function (select, i) {
        select.dataset.snOptionsBound = '1';
        select.addEventListener('change', function () {
          apply(product.variants, selects, i, false);
        });
      });
      apply(product.variants, selects, 0, true);
    });
  }

  function bindQuickViewDetails(product, modal) {
    if (!product || !product.handle || !Array.isArray(product.variants)) { return; }
    var form = modal.querySelector('form.product-form');
    var idField = form && form.querySelector('[name="id"]');
    if (!idField) { return; }

    modal.querySelectorAll('.product-meta__title a[href]').forEach(function (link) {
      if (link.dataset.snVariantLink === '1') { return; }
      var destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin || !destination.pathname.endsWith('/products/' + product.handle)) { return; }
      link.dataset.snVariantLink = '1';

      function refresh() {
        var variant = product.variants.find(function (item) { return String(item.id) === idField.value; });
        var selectors = form.querySelectorAll('select.product-form__single-selector, input.product-form__single-selector:checked');
        var matches = variant && Array.prototype.every.call(selectors, function (select) {
          var position = Number(select.dataset.optionPosition) - 1;
          return variant.options[position] === select.value;
        });
        if (matches) { destination.searchParams.set('variant', String(variant.id)); }
        else { destination.searchParams.delete('variant'); }
        link.href = destination.pathname + destination.search + destination.hash;
      }

      form.addEventListener('change', function () { requestAnimationFrame(refresh); });
      link.addEventListener('click', refresh);
      link.addEventListener('auxclick', refresh);
      link.addEventListener('contextmenu', refresh);
      refresh();
    });
  }

  function watchQuickViews() {
    document.querySelectorAll('[id^="modal-quick-view-"]').forEach(function (modal) {
      if (modal.dataset.snOptionsWatch === '1') { return; }
      modal.dataset.snOptionsWatch = '1';

      function bindContents() {
        modal.querySelectorAll('[data-product-json]').forEach(function (data) {
          if (data.dataset.snOptionsBound === '1') { return; }
          try {
            var product = JSON.parse(data.textContent).product;
            if (product && Array.isArray(product.variants) && product.variants.length < 250) {
              bind(product, modal);
            }
            bindQuickViewDetails(product, modal);
            data.dataset.snOptionsBound = '1';
          } catch (error) {}
        });
      }

      new MutationObserver(bindContents).observe(modal, { childList: true, subtree: true });
      bindContents();
    });
  }

  function boot() {
    watchQuickViews();
    if (!handle) { return; }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        bind(product, document);
      })
      .catch(function () { /* never break the page over this */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', watchQuickViews);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-secondary-action="open-quick-view"]')) { watchQuickViews(); }
  }, true);
})();

/* ---------------------------------------------------------------------------
 * VARIANT -> GALLERY IMAGE SYNC
 *
 * The product gallery never moved when the customer changed a colour. Shopify
 * held the right link all along - each variant carries its own featured media -
 * and the theme already honours it on FIRST PAINT: the carousel is rendered with
 * data-initial-media-id taken from the selected variant, so /products/x?variant=
 * lands on the right photo. What was missing was the client-side half. Once the
 * page is live, changing the Colour select swapped the variant, the price and
 * the SKU but left the gallery wherever it was, so a four-colour product could
 * read "Colour: Black" beside a photograph of the gold one.
 *
 * This listens for the theme's own 'variant:changed' event and moves the gallery
 * to that variant's featured media by clicking the matching thumbnail - the same
 * path a customer takes - so Flickity, the zoom and the thumbnail highlight all
 * stay in step. No theme internals are touched and no Flickity API is assumed.
 *
 * The click carries a one-shot preventDefault guard because the thumbnails are
 * anchors pointing at the full-size image: if the theme's own handler were ever
 * removed, an unguarded click would navigate away from the product page.
 *
 * Variants with no featured media, and single-image galleries, are left alone,
 * as is a gallery the customer is already browsing on that image.
 * ------------------------------------------------------------------------- */
(function () {
  if (location.pathname.indexOf('/products/') === -1) { return; }

  function selectedMediaId() {
    var current = document.querySelector('.product-gallery__carousel-item.is-selected');
    return current ? current.getAttribute('data-media-id') : null;
  }

  function show(mediaId) {
    if (!mediaId) { return; }
    mediaId = String(mediaId);
    if (selectedMediaId() === mediaId) { return; }

    var thumbnail = document.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');
    if (thumbnail) {
      var guard = function (event) { event.preventDefault(); };
      thumbnail.addEventListener('click', guard);
      try {
        thumbnail.click();
      } finally {
        setTimeout(function () { thumbnail.removeEventListener('click', guard); }, 0);
      }
      return;
    }

    // Galleries rendered without thumbnails expose dot navigation instead.
    var items = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__carousel-item'));
    var index = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-media-id') === mediaId) { index = i; break; }
    }
    if (index === -1) { return; }

    var dots = document.querySelectorAll('.product-gallery .flickity-page-dots .dot');
    if (dots[index]) { dots[index].click(); }
  }

  document.addEventListener('variant:changed', function (event) {
    try {
      var variant = event.detail && event.detail.variant;
      if (!variant || !variant.featured_media) { return; }
      show(variant.featured_media.id);
    } catch (error) {
      /* never break a product page over an image swap */
    }
  });
})();

(function () {
  var products = [
    { id: 8641375797406, handle: 'heavy-duty-aluminum-stair-nosing-65x42mm-for-wooden-and-carpet-floor', material: 'aluminium', dimensions: [1] },
    { id: 8641377697950, handle: 'standard-anti-slip-stair-nosings', material: 'grp', dimensions: [2, 3] },
    { id: 8641376354462, handle: 'anti-slip-medium-grit-durable-grp-stair-nosing-for-wooden-and-steel-step-edges', material: 'grp', dimensions: [1] },
    { id: 7406547271838, handle: 'stair-anti-slip-nosing-rubber-angle-step-edge-rgpd-900mm', material: 'rubber-nosing', dimensions: [1], descriptionQuote: true, samples: false }
  ];

  function positiveInteger(value) {
    return /^[1-9][0-9]*$/.test(value || '') && Number.isSafeInteger(Number(value));
  }

  function bindProductLink(item, select) {
    select = select || document.getElementById('product-select-' + item.id);
    var form = select && select.closest('form');
    if (!form) { return; }
    var quickView = form.closest('[id^="modal-quick-view-"]');
    var links = [form.querySelector('.sn65-quote__btn, [data-sn-project-quote]')].concat(quickView || item.samples === false ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-sn-samples-quote]')));
    if (!quickView && item.descriptionQuote) {
      var section = form.closest('.shopify-section');
      if (section) {
        links = links.concat(Array.prototype.slice.call(section.querySelectorAll('.product-block-list__item--description a[href]')));
      }
    }
    links.forEach(function (link) {
    if (!link || link.dataset.snQuoteBound === '1') { return; }
    var destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || !destination.pathname.endsWith('/pages/request-a-quote')) { return; }
    link.dataset.snQuoteBound = '1';

    function refresh() {
      var params = new URLSearchParams();
      if (link.hasAttribute('data-sn-samples-quote')) { params.set('quote_samples', '1'); }
      if (positiveInteger(select.value)) {
        params.set('quote_product', item.handle);
        params.set('quote_variant', select.value);
        var quantity = form.querySelector('[name="quantity"]');
        if (quantity && positiveInteger(quantity.value.trim())) { params.set('quote_quantity', quantity.value.trim()); }
      }
      destination.hash = params.toString();
      link.href = destination.pathname + destination.search + destination.hash;
    }

    form.addEventListener('input', refresh);
    form.addEventListener('change', function () { requestAnimationFrame(refresh); });
    if (!quickView) { document.addEventListener('variant:changed', refresh); }
    link.addEventListener('click', refresh);
    link.addEventListener('auxclick', refresh);
    link.addEventListener('contextmenu', refresh);
    refresh();
    });
  }

  function watchQuickViews() {
    document.querySelectorAll('[id^="modal-quick-view-"]').forEach(function (modal) {
      if (modal.dataset.snQuoteWatch === '1') { return; }
      modal.dataset.snQuoteWatch = '1';

      function bind() {
        products.forEach(function (item) {
          modal.querySelectorAll('[id="product-select-' + item.id + '"]').forEach(function (select) {
            bindProductLink(item, select);
          });
        });
      }

      // Quick view replaces its contents after fetching the product form.
      // Keep its quote links local, without changing the page's samples link.
      new MutationObserver(bind).observe(modal, { childList: true, subtree: true });
      bind();
    });
  }

  function prefillQuote() {
    var form = document.querySelector('form.quote-form');
    if (!form || form.dataset.snProductQuote === '1') { return; }
    var params = new URLSearchParams(window.location.hash.slice(1));
    var variantId = params.get('quote_variant');
    var item = products.find(function (entry) { return entry.handle === params.get('quote_product'); });
    if (!item || !positiveInteger(variantId)) { return; }
    form.dataset.snProductQuote = '1';
    var edited = new WeakSet();
    Array.prototype.forEach.call(form.querySelectorAll('input,select,textarea'), function (field) {
      field.addEventListener('input', function () { edited.add(field); });
      field.addEventListener('change', function () { edited.add(field); });
    });

    function fill(id, value) {
      var field = form.querySelector('#' + id);
      if (field && !field.value.trim() && !edited.has(field) && value) { field.value = value; }
    }

    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    fetch(root + 'products/' + item.handle + '.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || product.id !== item.id || !Array.isArray(product.variants)) { return; }
        var variant = product.variants.find(function (item) { return String(item.id) === variantId; });
        if (!variant) { return; }
        var quantity = params.get('quote_quantity');
        var productUrl = new URL(root + 'products/' + item.handle, window.location.origin);
        productUrl.searchParams.set('variant', variantId);
        fill('contact_nosing_type', item.material);
        fill('contact_dimensions', item.dimensions.map(function (position) { return variant['option' + position]; }).filter(Boolean).join(' / '));
        // Pieces and length per piece are separate from the number of steps.
        if (positiveInteger(quantity)) { fill('contact_pieces', quantity); }
        var lengthMatch = item.dimensions.map(function (position) { return variant['option' + position] || ''; }).join(' ').match(/(\d{3,4})\s*mm/);
        if (lengthMatch) { fill('contact_piece_length', lengthMatch[1] + 'mm'); }
        var selection = positiveInteger(quantity) ? quantity + ' × ' + variant.title : variant.title;
        fill('contact_message', [product.title, selection, productUrl.href].join('\n'));
      })
      .catch(function () {});
  }

  function prefillSamples() {
    var form = document.querySelector('form.quote-form');
    var params = new URLSearchParams(window.location.hash.slice(1));
    if (!form || form.dataset.snSampleIntent === '1' || params.get('quote_samples') !== '1') { return; }
    var checkbox = form.querySelector('input[name="contact[samples]"]');
    if (!checkbox) { return; }
    form.dataset.snSampleIntent = '1';
    checkbox.checked = true;
  }

  function boot() {
    prefillSamples();
    products.forEach(function (item) { bindProductLink(item); });
    watchQuickViews();
    prefillQuote();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('hashchange', prefillSamples);
})();

(function () {
  var nextId = 0;

  function productMain() {
    var main = document.querySelector('main');
    return main && main.querySelector('#product-select-8641375797406') ? main : null;
  }

  function setExpanded(button, answer, expanded) {
    button.classList.toggle('open', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    answer.hidden = !expanded;
    answer.style.maxHeight = expanded ? 'none' : '0px';
  }

  function bindProductFaqs() {
    var main = productMain();
    if (!main) { return; }

    main.querySelectorAll('.product-block-list__item--description .sn-faq-q').forEach(function (button) {
      var answer = button.nextElementSibling;
      if (!answer || !answer.classList.contains('sn-faq-a') || button.dataset.snFaqBound === '1') { return; }

      if (!answer.id) {
        var answerId;
        do { answerId = 'sn65-faq-answer-' + (++nextId); } while (document.getElementById(answerId));
        answer.id = answerId;
      }
      button.dataset.snFaqBound = '1';
      button.type = 'button';
      button.removeAttribute('onclick');
      button.setAttribute('aria-controls', answer.id);
      setExpanded(button, answer, button.classList.contains('open'));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-block-list__item--description .sn-faq-q');
    var main = productMain();
    if (!button || !main || !main.contains(button)) { return; }
    bindProductFaqs();
    var answer = button.nextElementSibling;
    if (button.dataset.snFaqBound === '1' && answer && answer.classList.contains('sn-faq-a')) {
      setExpanded(button, answer, button.getAttribute('aria-expanded') !== 'true');
    }
  }, true);

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bindProductFaqs); }
  else { bindProductFaqs(); }
  document.addEventListener('shopify:section:load', bindProductFaqs);
})();

// Basket quantity boxes: letters or negatives used to send quantity=NaN to /cart/change and show
// Shopify's raw error page. Restore the previous value instead (handover D08, 2026-10-20).
(function () {
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.quantity-selector:not(.quantity-selector--product) .quantity-selector__value')) { return; }
    if (/^[0-9]+$/.test(input.value.trim())) { return; }
    event.stopImmediatePropagation();
    input.value = input.getAttribute('data-current-value') || '1';
  }, true);
})();

// D10 (2026-10-20): sticky buy box only when it fits the window; quick view returns focus to its
// opener and is announced as a dialog; client-logo marquee respects reduced motion.
(function () {
  function fitSticky() {
    var cards = document.querySelectorAll('.card--sticky');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      c.classList.remove('sn-sticky-off');
      if (window.innerWidth < 1000) continue;
      var top = parseFloat(window.getComputedStyle(c).top) || 0;
      if (c.offsetHeight > window.innerHeight - top) c.classList.add('sn-sticky-off');
    }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(fitSticky, 150); }
  window.addEventListener('load', fitSticky);
  window.addEventListener('resize', soon);
  document.addEventListener('variant:changed', soon);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(soon);
    document.addEventListener('DOMContentLoaded', function () {
      var cards = document.querySelectorAll('.card--sticky');
      for (var i = 0; i < cards.length; i++) ro.observe(cards[i]);
    });
  }
  if (document.readyState !== 'loading') fitSticky(); else document.addEventListener('DOMContentLoaded', fitSticky);

  var opener = null;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[aria-controls^="modal-quick-view-"]');
    if (b) opener = b;
  }, true);
  function watchModals() {
    var modals = document.querySelectorAll('[id^="modal-quick-view-"]');
    for (var i = 0; i < modals.length; i++) {
      var m = modals[i];
      if (m.dataset.snFocusWatch === '1') continue;
      m.dataset.snFocusWatch = '1';
      m.setAttribute('role', 'dialog');
      m.setAttribute('aria-modal', 'true');
      if (!m.hasAttribute('aria-label')) m.setAttribute('aria-label', 'Quick view');
      new MutationObserver(function (records) {
        records.forEach(function (r) {
          var el = r.target;
          if (el.getAttribute('aria-hidden') === 'true' && opener && document.contains(opener)) {
            var o = opener; opener = null;
            setTimeout(function () { o.focus(); }, 0);
          }
        });
      }).observe(m, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }
  if (document.readyState !== 'loading') watchModals(); else document.addEventListener('DOMContentLoaded', watchModals);

  function marquee() {
    var mq = document.getElementById('sn-clients-marquee');
    var btn = document.querySelector('.sn-marquee-toggle');
    if (!mq || !btn) return;
    function set(paused) {
      if (paused) { if (mq.stop) mq.stop(); } else if (mq.start) mq.start();
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.textContent = paused ? 'Play client logos' : 'Pause client logos';
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    set(Boolean(reduce));
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-pressed') !== 'true'); });
  }
  if (document.readyState !== 'loading') marquee(); else document.addEventListener('DOMContentLoaded', marquee);
})();

// D09 (2026-10-21): lead measurement. Publishes Shopify custom events that a Customer Events pixel can
// forward to GA4 / Ads. No personal form data is sent. A quote success is published once, after a real
// submission (the POST redirect), never on reload or back/forward. Contact clicks are a separate event,
// so they are not counted as leads.
(function () {
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function quoteSuccess() {
    if (!document.getElementById('quote-form-success')) return;
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && (nav.type === 'reload' || nav.type === 'back_forward')) return;
    publish('sn_quote_submitted', { form: 'quote', page: location.pathname });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quoteSuccess); else quoteSuccess();
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    var method = /^tel:/i.test(h) ? 'phone' : /^mailto:/i.test(h) ? 'email' : /wa\.me|whatsapp/i.test(h) ? 'whatsapp' : null;
    if (method) publish('sn_contact_click', { method: method, page: location.pathname });
  }, true);
})();
